import { inject, injectable } from "inversify";
import { CatalogueRepository } from "@catalogue/data/repositories/catalogue.repository";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";

@injectable()
export class DeleteServiceUseCase {
    constructor(
        @inject(CatalogueRepository)
        private readonly catalogueRepository: CatalogueRepository,
    ) { }

    async execute(serviceId: number): Promise<boolean> {

        const result = await this.catalogueRepository.deleteService(serviceId);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        return result.fold(
            () => false,
            (result) => {
                return result;
            }
        );

    }
}